
import Vue from 'vue';
export default Vue.extend({
  name: 'HelpIcon',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
});
